import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { App, Button, Card, Col, DatePicker, Form, Input, Row, Select, Spin } from 'antd'
import React, { useState } from 'react'
import { queryKeys } from '../../../services/react-query/queryKeys';
import { getPatients } from '../../../network/appointment';
import { addPatientInsurancePolicy, getEligibilityPlans, getInsurancePayors, getPatientInsurancePoliciesById, updatePatientInsurancePolicy } from '../../../network/PatientInsurancePolicy';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';

const PatientInsurancePolicyAdd = ({t,edit}) => {
    // addPatientInsurancePolicy;
    const {id} = useParams();
    const [loadingAdd, setLoadingAdd] = useState(false);
    const navigate = useNavigate();
    const client = useQueryClient();
    const [form] = Form.useForm();
    const {message} = App.useApp();
        const { data: patients } = useQuery({
          queryKey: [queryKeys.getPatients],
          queryFn: () => getPatients(),
          keepPreviousData: true,
        });
        const { data: payors } = useQuery({
          queryKey: [queryKeys.getInsurancePayors],
          queryFn: () => getInsurancePayors(),
          keepPreviousData: true,
        });
        const { data: plans } = useQuery({
          queryKey: [queryKeys.getEligibilityPlans],
          queryFn: () => getEligibilityPlans(),
          keepPreviousData: true,
        });
             const { mutate: onAddPatientInsurancePolicy } = useMutation({
               mutationKey: ['addPatientInsurancePolicy'],
               mutationFn: (body) =>
                 edit
                   ? updatePatientInsurancePolicy({body,id})
                   : addPatientInsurancePolicy(body),
               onSuccess: (data) => {
                 setLoadingAdd(false);
                 // console.log(data?.message, 'datawwww');
                 if (data?.message?.status === 500) {
                   message.error(data?.message?.message);
                   return false;
                 }
                 // edit
                 //   ? message.success('Patient edited successfully')
                 //   : message.success('Patient added successfully');
                 message.success(data?.message?.message);
                 client.invalidateQueries({
                   queryKey: [queryKeys.addPatientInsurancePolicy],
                 });
                 form.resetFields();
                 navigate('/patient_insurance_policy');
               },
               onError: (error) => {
                 setLoadingAdd(false);
                 console.log('error:', error);
                 // message.error(error);
               },
             });
    const onFinish = (values) => {
        console.log('Finish:', values);
        setLoadingAdd(true);
        onAddPatientInsurancePolicy({
            ...values,
            date: dayjs(values?.date).format('YYYY-MM-DD'),
            policy_expiry_date : dayjs(values?.policy_expiry_date).format('YYYY-MM-DD'),
          
        });
    };
    const { data: dataById, isLoading } = useQuery({
      queryKey: [queryKeys.getPatientInsurancePoliciesById, id],
      queryFn: () => getPatientInsurancePoliciesById(id),
      enabled: !!edit,
    });
    if(isLoading){
        return (<div
          style={{
            width: '100%',
            height: '80vh',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <Spin size='large' />
        </div>)
    }
  return (
    <div className="patient-insurance-policy">
      <Card>
        <h4 className="title-card">
          {t.ENTERPATIENTINSURANCEPOLICYINFORMATION}
        </h4>
        <Form
          layout="vertical"
          name="nest-messages"
          onFinish={onFinish}
          form={form}
          initialValues={
            edit ? {
              ...dataById?.data,
              date: dayjs(dataById?.data?.date),
              policy_expiry_date: dayjs(dataById?.data?.policy_expiry_date),

            } : {}
          }
        >
          <Row gutter={[16, 0]}>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="patient"
                label={t.patientFileNumber}
                rules={[
                  {
                    required: true,
                    message: t.requiredPatientFileNumber,
                  },
                ]}
              >
                <Select
                  placeholder={t.patientFileNumber}
                  showSearch
                  optionFilterProp="children"
                  filterOption={(input, option) =>
                    (option?.label ?? '').toLocaleLowerCase().includes(input)
                  }
                  filterSort={(optionA, optionB) =>
                    (optionA?.label ?? '')
                      .toLowerCase()
                      .localeCompare((optionB?.label ?? '').toLowerCase())
                  }
                  onChange={(value, option) => {
                    console.log(option);
                    form.setFieldsValue({
                       patient_name: option.data.patient_name,
                       gender: option.data.sex,
                       country: option.data.country,
                       });
                  }}
                  options={patients?.message?.message?.map((item) => ({
                    value: item?.name,
                    label: item?.custom_file_number,
                    data: item,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="patient_name"
                label={t.patientName}
                rules={[
                  {
                    required: true,
                    message: t.requiredPatientName,
                  },
                ]}
              >
                <Input placeholder={t.patientName} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="gender"
                label={t.gender}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder={t.gender} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="country"
                label={t.Country}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Input placeholder={t.Country} disabled />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="insurance_payor"
                label={t.insurancePayor}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  placeholder={t.insurancePayor}
                  options={payors?.message?.insurance_payors?.map((item) => ({
                    value: item?.name,
                    label: item?.insurance_payor_name,
                  }))}
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="date"
                label={t.date}
                initialValue={dayjs()}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <DatePicker
                  placeholder={t.date}
                  style={{ width: '100%' }}
                  defaultValue={dayjs()}
                  format="YYYY-MM-DD"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="policy_expiry_date"
                label={t.PolicyExpiryDate}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <DatePicker
                  placeholder={t.PolicyExpiryDate}
                  style={{ width: '100%' }}
                  format="YYYY-MM-DD"
                />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="policy_number"
                label={t.PolicyNumber}
                rules={[
                  {
                    required: true,
                  },
                  {
                    min: 10,
                    message: 'Policy Number must be at least 10 characters',
                  },
                ]}
              >
                <Input type="number" placeholder={t.PolicyNumber} />
              </Form.Item>
            </Col>
            <Col xs={24} sm={12} md={8} lg={8}>
              <Form.Item
                name="insurance_plan"
                label={t.InsurancePlan}
                rules={[
                  {
                    required: true,
                  },
                ]}
              >
                <Select
                  placeholder={t.InsurancePlan}
                  options={plans?.message?.eligibility_plans?.map((item) => ({
                    value: item?.name,
                    label: item?.insurance_plan_name,
                  }))}
                />
              </Form.Item>
            </Col>
          </Row>
          <div className="form-btns">
            <Button type="primary" ghost onClick={() => navigate(-1)}>
            {t.Cancel}
            </Button>
            <Button type="primary" htmlType="submit" loading={loadingAdd}>
              {edit ? t.edit : t.submit}
            </Button>
          </div>
        </Form>
      </Card>
    </div>
  );
}

export default PatientInsurancePolicyAdd